import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { RouterStore } from 'mobx-react-router';
import CurrentPartnerStore from '../../../CurrentPartner/Store/CurrentPartnerStore';
import ProgressStore from '../../../Progress/Stores/ProgressStore';
import ReportStore from '../../../Report/Stores/ReportStore';
import SyncStatus from '../../../Report/SubElements/Success/Models/SyncStatus';
import RetirementStore from '../../Store/RetirementStore';
import ProgressBar from '../../../Progress/Components/ProgressBar';
import ProviderStore from '../../../Providers/Stores/ProviderStore';

interface ProgressComponentProps {
    progress?: ProgressStore,
    currentPartner?: CurrentPartnerStore,
    retirementStore?: RetirementStore,
    routing?: RouterStore,
    provider: ProviderStore,
}

const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
};

@inject('progress','provider', 'currentPartner', 'retirementStore', 'routing')
@observer
export default class SyncingRetirementComponent extends Component<ProgressComponentProps> {

    backToUpload = (): void => {
        this.props.routing!.replace('/partner/retirement');
    }

    backToAllPartner = async ():Promise<any> => {
        let count = await this.props.provider.getActiveCourseCount(this.props.currentPartner.selectedPartner.providerId);
        this.props.currentPartner.selectedPartner.activeCourseCount = count.numberOfCourses;
        this.props.currentPartner.setJournal(count.journal);
        this.props.routing!.replace('/partner');
    }

    render() {
        if (this.props.retirementStore.SyncSuccess == SyncStatus.Synced) return <div className='sync-container'>
            <div className="sync-text-block">
                <h2>{this.props.retirementStore.Success.items.length + " Courses will be Successfully Retired on " + new Date(this.props.retirementStore.Success.items[0].date).toLocaleString("en-US", options)}</h2>
            </div>
            <div className="sync-icon-success-block">
                <FontAwesomeIcon size="6x" className="sync-icon" icon={faCheckCircle} />
            </div>
            <div className="sync-links">
                <span className="new-user-link margin-link-sync" onClick={this.backToAllPartner.bind(this)}>Back to Manage Content</span>
                <span className="new-user-link margin-link-sync" onClick={this.backToUpload.bind(this)}>Back to Submit Courses for Retirement</span>
            </div>
        </div>
        else return <div className='sync-container'>
            <div className="sync-text-block">
                <h2>{"Processing " + this.props.retirementStore.Success.items.length + " for Retirement Now"}</h2>
            </div>
            <div className='row progress-sync'>
                <ProgressBar percent={this.props.progress.currentProcess.Percent}></ProgressBar>
            </div>
            <div className="sync-text">
                <span className="text-sync-info">Please do not close the browser while syncing</span>
                <span className="text-sync-info">Doing so can result in a loss of data</span>
            </div>
        </div>
    }

}